import { MembershipInvitesStatuses, MembershipMatchWarning } from 'constants/membership';
import { PLATFORM_DISPLAY_SHORT_NAME } from 'constants/platform';
import { SETTINGS_ACCOUNT_TEAM_MEMBERS_ROUTE } from 'constants/routes';

/**
 * Text constants for AboutNegativeBalanceHint.
 * @type {Object}
 */
export const aboutNegativeBalanceHint = {
  textAfterLink: 'about negative balances.',
  textBeforeLink:
    'A negative balance is likely caused by insufficient funds. Our records show you processed a payment and did not have enough money in your selected bank account.',
  title: 'About your negative balance',
};

/**
 * Text constants for AboutNegativeBalanceHint.
 * @type {Object}
 */
export const aboutPendingBalanceHintTitle = 'About your pending balance';

/**
 * Text constants for AmountTransactionMinimumHint.
 */
export const amountTransactionMinimumHint = {
  learnMore: 'Learn more about transaction limits',
  title: "This transaction doesn't meet the minimum amount",
};

/**
 * Text constants for CannotInviteTeamMemberAlreadyUserHint.
 * @type {Object}
 */
export const cannotInviteTeamMemberAlreadyUserHint = {
  [MembershipMatchWarning[MembershipInvitesStatuses.ACCEPTED_AND_VERIFIED]]: {
    // TODO DEV-23: Add correct link
    linkPath: SETTINGS_ACCOUNT_TEAM_MEMBERS_ROUTE,
    linkText: 'View their team member account',
    textAfterLink: '.',
    textBeforeLink: 'Their account is currently active.',
  },
  [MembershipMatchWarning.INACTIVE]: {
    // TODO DEV-23: Add correct link
    linkPath: SETTINGS_ACCOUNT_TEAM_MEMBERS_ROUTE,
    linkText: 'managing their team member account',
    textAfterLink: '.',
    textBeforeLink: 'Their account is currently inactive. You can reactivate their account by',
  },
};

/**
 * Text constants for DeactivateTeamMemberApproverWarningHint
 * @type {Object}
 */
export const deactivateTeamMemberApproverWarningHint = {
  title: 'This team member is an approver',
  linkText: 'Contact support to re-assign pending approval requests.',
};

/**
 * Text constants for NotVerifiedForTransactionsHint.
 * @type {Object}
 */
export const notVerifiedForTransactionsHint = {
  verifyButton: 'Verify my account',
  text: `Prior to releasing payments, please verify your account by following the ${PLATFORM_DISPLAY_SHORT_NAME} Guide. There you will be able to verify your business entity and any representatives.`,
  title: 'Your account is not verified for transactions',
};

/**
 * Gets NumberOfErrorsShownHint text
 * @type {string}
 */
export const numberOfErrorsShownHintText = 'Download the error report below for a complete list of detected errors';

/**
 * Text constants for EmailAlreadyInvitedHint.
 * @type {Object}
 */
export const emailAlreadyInvitedHint = {
  textBeforeLink: 'You can resend or revoke their invite by',
  linkText: 'managing their invites.',
};

/**
 * Text constants for EmailAssociatedWithOtherCompanies.
 * @type {Object}
 */
export const emailAssociatedWithOtherCompaniesHint = {
  title: 'This email is associated with at least one other company:',
  text: 'Confirm this contact should be associated with multiple companies',
};
